














import { defineComponent, PropType, watch, reactive, ref } from '@vue/composition-api';
import { Placement } from '@popperjs/core';
import Vue from 'vue';
import { VPopover } from 'v-tooltip';

Vue.component('v-popover', VPopover);
export default defineComponent({
	props: {
		open: {
			type: Boolean,
			default: false,
		},
		placement: {
			type: String as PropType<Placement>,
			default: 'right-start' as Placement,
		},
		offset: {
			type: Number,
			default: 10,
		},
		color: {
			type: String,
		},
		trigger: {
			type: String as PropType<'click' | 'hover'>,
		},
		popoverOptions: {
			type: Object,
		},
		popperOptions: {
			type: Object,
		},
	},
	setup(props) {
		const popoverRef = ref<Record<string, any> | null>(null);
		const state = reactive({
			open: props.open,
			// add popover options like this in order to be able to overwrite "default" values
			// (e.g. when attempting to overwrite the popoverInnerClass)
			consolidatedPopoverOptions: {
				popoverInnerClass: ['olb-tooltip', props.color && `bg-${props.color}`],
				offset: props.offset,
				popperOptions: props.popperOptions,
				placement: props.placement,
				trigger: 'manual',
				...props.popoverOptions,
			},
		});
		watch(props, () => {
			state.open = props.open;
		});

		function setOpen(event?: Event) {
			if (props.trigger && event) {
				if (
					(event.type === 'mouseenter' && props.trigger === 'hover') ||
					(event.type === 'click' && props.trigger === 'click')
				) {
					popoverRef?.value?.show();
				}
			}
		}

		function setClose() {
			if (props.trigger) {
				popoverRef?.value?.hide();
			}
		}

		return { state, setOpen, setClose, popoverRef };
	},
});
